import { gql } from '@apollo/client';

export const GET_FAILED_TEST_RESULTS_FOR_FFIEC041 = gql`
query getFailedTestResultsForFFIEC041($input: GetFailedTestResultsForFFIEC041Input) {
  getFailedTestResultsForFFIEC041(input: $input) {
    criteria {
      ruleId
      batchId
      isActive
      editChange
      editType
      editNumber
      effectiveStartDate
      effectiveEndDate
      mdrmList
      schedule
      targetItem
      ruleDescription
    }
    testResults{
      rowId
      testDate
      errorData
      errorColumns
      errorMessage
      errorDescription
      testPass
      testFail
      testError
      testRunStatus
    }
    pagination {
      totalCount
    }
  }
}
`;

export const GET_RULE_AUDIT_LOGS_FOR_FFIEC041 = gql`
query getAuditLogsForFFIEC041($input: GetAuditLogsForFFIEC041Input) {
  getAuditLogsForFFIEC041(input: $input) {
    auditLogId
    eventId
    batchId
    ruleId
    commentId
    commentText
    userId
    user {
      firstName
      lastName
      initials
    }
    event {
      eventName
    }
    comment {
      commentText
    }
    createdAt
  }
}
`;

export const GET_COMMENTS_FOR_FFIEC041 = gql`
query getUserCommentsForFFIEC041($input: GetUserCommentForFFIEC041Input) {
  getUserCommentsForFFIEC041(input: $input) {
    commentText
    commentId
    userId
    user{
    firstName
    lastName
    initials
  }
  FFIEC041AuditLog{
    auditLogId
    eventId
    createdAt
    commentId
  }
  }
}
`;

export const GET_BATCH_TESTS_FOR_FFIEC041 = gql`
query getFFIEC041BatchTests($input: GetFFIEC041BatchTestsInput) {
  getFFIEC041BatchTests(input: $input) {
    batchId
    totalRecords
    batchRunStatus
    batchStartTime
    ruleId
    period
    targetItem
    schedule
    mdrm
    isActive
    isRuleApplicable
    ruleDescription
    updatedAt
    fileName
    testError
    testFail
    testPass
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestExecuted
    totalTestFailed
    totalTestInError
  }
}
`;

export const GET_QUARTER_FILTERED_BATCH_TESTS_FOR_FFIEC041 = gql`
query getFFIEC041BatchTestsByQuarter($input: GetFFIEC041BatchTestsByQuarterInput) {
  getFFIEC041BatchTestsByQuarter(input: $input) {
    batchId
    ruleId
    period
    targetItem
    schedule
    mdrm
    isActive
    isRuleApplicable
    ruleDescription
    updatedAt
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    batchRunStatus
    batchStartTime
  }
}`;

export const GET_SUMMARY_QUARTERS_FOR_FFIEC041 = gql`
query getFFIEC041SummaryQuarters($input: TenantIdInput) {
  getFFIEC041SummaryQuarters(input: $input)
}`;

export const GET_DOWNLOADED_RESULT = gql`
query getFFIEC041SummaryDetailsForDownload($input: GetFFIEC041BatchTestsByQuarterInput) {
  getFFIEC041SummaryDetailsForDownload(input: $input) {
    batchId
    ruleId
    period
    targetItem
    schedule
    mdrm
    isActive
    ruleDescription
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    batchRunStatus
    batchStartTime
  }
}`;

export const GET_LATEST_BATCH_FOR_FFIEC041 = gql`
query getCurrentStatusOfLatestBatchForFFIEC041($input: TenantIdInput) {
  getCurrentStatusOfLatestBatchForFFIEC041(input: $input) {
    batchRunStatus
    batchId
    batchEndTime
    batchStartTime
    totalRecords
    fileName
    totalTestCases
  }
}`;
